const config = {
  app: {
    prefix: "afcd",
    title: "ARM Field Campaigns",
    host: "https://localhost.ornl.gov:8080/afcd",
  },
  auth: {
    cas: "https://cas.dev.arm.gov/cas",
    authService: "https://armweb-dev.ornl.gov/Auth/",
    serviceName: "https://localhost:8080/afcd",
    logout: "https://cas.dev.arm.gov/cas/logout",
    sessionExpirationMinutes: 30,
    sessionWarningMinutes: 25,
  },
  graphql: {
    host: "https://postgraphile-api.dev.arm.gov/graphql",
  },
  fieldCampaignDashboardFileApi: {
    host: "https://armweb-dev.ornl.gov/Auth/field-catalog-file-api",
  },
  google: {
    recaptchaKey: "6LdzDTYUAAAAAL05blc17MfL5erA19qPaRfKngtH",
  },
  notification: {
    baseURL: "https://armweb-dev.ornl.gov/NotificationService",
    emailRegex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
  },
  sso: {
    logout: "https://cas.dev.arm.gov/cas/logout",
  },
  profile: {
    baseUrl: "https://armweb-dev.ornl.gov/profile/preference",
    userRegUrl: "https://armweb-dev.ornl.gov/armuserreg",
  },
  plots: {
    baseUrl: "https://plot.dmf.arm.gov/PLOTS/",
    videoThumbBaseUrl: "https://plot.dmf.arm.gov/plotbrowser/thumbs/",
  },
  session: {
    authService: true,
    graphQL: true,
    sessionExpirationMinutes: 30,
    sessionWarningMinutes: 25,
  },
  maintenance: {
    maintenanceToolUrl: "https://armweb-dev.ornl.gov/ARMMaintenanceTools/#",
    pmApiUrl: "https://armweb-dev.ornl.gov/Auth/arm-pmreport-api",
    cmApiUrl: "https://armweb-dev.ornl.gov/Auth/arm-cmreport-api",
    pmApiSearchUrl: "https://armweb-dev.ornl.gov/Auth/arm-pmreport-api/report/search/spec",
    cmApiSearchUrl: "https://armweb-dev.ornl.gov/Auth/arm-cmreport-api/custom/search/spec",
  },
  maintenanceCheck: {
    url: "https://maintenance-check-api.dev.arm.gov/arm",
  },
}
//serviceName: "https%3A%2F%2Flocalhost.ornl.gov%3A8080%2Ffieldcatalog%2F",

export default config
